import { TypePolicies } from '@apollo/client';

const CAPAQuotationRfqPurchaseOrdersOutputCache: TypePolicies = {
  CAPAQuotationRfqPurchaseOrdersOutput: {
    merge(existing, incoming, { mergeObjects }) {
      return mergeObjects(existing, incoming);
    }
  }
};

export default CAPAQuotationRfqPurchaseOrdersOutputCache;
